
selectSiteThenPublication.$inject = ['$stateParams', '$filter', 'MessageConditionFactory'];
export function selectSiteThenPublication($stateParams, $filter, MessageConditionFactory) {

  controller.$inject = ['$scope'];
  function controller($scope) {

    $scope.onSiteChange = onSiteChange;
    
    init();
  
    function onSiteChange() {
      updatePublicationsList();
      $scope.directiveModel.publicationId = null;
    }
    
    function updatePublicationsList() {
      if ($scope.siteId) {
        $scope.isLoading = true;
        MessageConditionFactory.listPublicPosts($stateParams.companyId, $scope.siteId).then(
          response => {
            $scope.publicationsList = response.data.map(publication => ({
              'id': publication.id,
              'label': `${$filter('dateTimezone')(publication.created_time, 'shortDate')} - ${truncate(publication.content)}`,
              'content': truncate(publication.content),
              'externalUrl': publication.external_url,
              'createdTime': publication.created_time,
              'sortKey': publication.created_time,
            }));
            updateExternalUrlAndContent();
          }
        ).finally(() => $scope.isLoading = false); 
      } else {
        $scope.publicationsList = [];
      }
    }

    function truncate(content) {
      return (content.length <= 40) ? content : (content.substring(0, 40) + '\u2026');
    }

    function updateExternalUrlAndContent() {
      $scope.externalUrl = null;
      $scope.publicationsList.filter(pub => pub.id === $scope.publicationId).forEach(pub => {
        $scope.externalUrl = pub.externalUrl;
        $scope.content = pub.content;
        $scope.createdTime = pub.createdTime;
      });
    }
  
    function init() {
      if (!$scope.readonly) {
        $scope.publicationsList = [];
        // Work around ng-ifs and ng-repeats creating child scopes 
        // (see e.g. https://stackoverflow.com/questions/18342917/angularjs-ng-model-doesnt-work-inside-ng-if )
        $scope.directiveModel = {
          'siteId': $scope.siteId,
          'publicationId': $scope.publicationId
        }
        // But in addition we need to forward any new value up to our parent scope 
        // (angular watches $scope.groupModel and $scope.valuesModel because we declared them with '=' in the directive definition)
        $scope.$watch("directiveModel.siteId", (newValue, oldValue) => {
          $scope.siteId = newValue;
          if (newValue != oldValue) {
            onSiteChange();
          }
        });
        $scope.$watch("directiveModel.publicationId", newValue => {
          $scope.publicationId = newValue;
          updateExternalUrlAndContent();
        });
        updatePublicationsList();  
      }
    }
  }

  return {
    restrict: 'E',
    template: require('./select-site-then-publication.directive.html'),
    scope: {
      siteId: '=',
      publicationId: '=',
      content: '=',
      createdTime: '=',
      externalUrl: '=',
      siteItems: '<',
      readonly: '<',
    },
    controller: controller
  };

}








